import { useState, useEffect } from "react";
import "./ResponseContentDate.css";
import { Question } from "effno-core";
import { useSelector } from "react-redux";
import { selectUIStates } from "../../redux/features/appData";
import { ResponseNavigate } from "./ResponseNavigate";
import { DateResponse } from "../config/responseSettings";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import config from "environment";
import { DATE_FORMATS } from "../config/questionSettings";
import { ResponseErrors } from "./responseErrors";
import { NEXT_BUTTON } from "./ResponseContent";
import { TriangleAlert } from "lucide-react";

const debugMode = config.debugMode;

type ResponseContentDateProps = {
    question: Question;
    responseValues: string;
    isPreview: boolean;
    isMobileLayout: boolean;
    isLastQuestion: boolean;
    commentMode: boolean;
    onNext?: () => void;
    onPrev?: () => void;
    onSubmit: (responseValues: string) => void;
}

export const ResponseContentDate = ({
    question,
    responseValues,
    isPreview,
    isMobileLayout,
    isLastQuestion,
    commentMode,
    onNext,
    onPrev,
    onSubmit
} : ResponseContentDateProps) => {

    // const uiStates = useSelector(selectUIStates);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const [error, setError] = useState<string>("");

    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);

        const dateText = JSON.parse(responseValues).date;
        if (dateText) {
            setSelectedDate(new Date(dateText));
        } else {
            setSelectedDate(null);
        }
        setError(ResponseErrors.none);
    }, [question, responseValues])

    const metRequirements = () => {
        return !question.required || selectedDate !== null;
    }

    const handleNext = () => {
        if (isPreview && onNext) {
            onNext();
        } else {
            handleSubmit();
        }
    }

    const handleSubmit = () => {
        if (question.required && !selectedDate) {
            setError("This field is required");
            return;
        }

        const newResponseValues: string = JSON.stringify({
            date: selectedDate ? selectedDate.toDateString() : ""
        } as DateResponse);

        console.log("[ResponseContentDate] selectedDate: ", selectedDate);
        console.log("[ResponseContentDate] newResponseValues: ", newResponseValues);

        onSubmit(newResponseValues);
    }

    // const handleChange = (newDate: Date) => {
    //     setSelectedDate(newDate);
    // }

    const requirementsMet =  metRequirements();

    const settings = question.settings ? JSON.parse(question.settings) : {};
    let datePickerFormat = "MM/dd/yyyy";

    if (settings.dateFormat) {
        const index = DATE_FORMATS.findIndex((format) => format === settings.dateFormat);
        
        if (index !== -1) {
            datePickerFormat = ["MM/dd/yyyy", "dd/MM/yyyy", "yyyy/MM/dd"][index];
        }
    }
    
    // console.log("[ResponseContentDate] question: ", question);
    // console.log("[ResponseContentDate] values: ", responseValues);
    // console.log("[ResponseContentDate] text: ", text);


    return (
        <div className="form-content-body">

            {/* {debugMode && question &&
                <div className="response-content-question-id">
                    {question.id}
                </div>
            } */}
            
            <div 
                className="response-content-title"
                data-testid={"response-content-title:" + title}
            >
                {title}
            </div>
            
            <div className="response-content-description">
               {description}
            </div>   

            <div 
                style={{marginTop: "40px"}} 
                className="response-content-date"
                data-testid="response-content-date"
            >
                <DatePicker 
                    selected={selectedDate ? selectedDate : new Date()} 
                    dateFormat={datePickerFormat}
                    onChange={(date) => setSelectedDate(date)} 
                    className="response-content-date-picker-input"
                    wrapperClassName="response-content-date-picker-wrapper"
                />
            </div>    
            
            <div 
                className="response-content-error"
                style={!error ? {backgroundColor: "transparent"} : {}}
                data-testid="response-content-error"
            >
                {error && <TriangleAlert size={16}/>}{error}
            </div>

            {/* <div className="response-content-submit">
                <button
                    className="response-content-button-submit"
                    onClick={handleSubmit}
                    data-testid="response-content-submit"
                >
                    {onNext ? NEXT_BUTTON : "Submit"}
                </button>
            </div> */}

            <ResponseNavigate 
                isMobileLayout={isMobileLayout}
                isLastQuestion={isLastQuestion}
                commentMode={commentMode}
                onSubmit={handleSubmit}
                onNext={handleNext}
                onPrev={onPrev}
            />

        </div>
    )
}